module.exports = __webpack_public_path__ + "media/bootstrap-icons/box-arrow-down-8e002205.svg";